import Lenis from 'lenis'

function lenisScroll () {
  const lenis = new Lenis({
    autoRaf: true, // Lenis maneja su propio RAF (no depende de GSAP)
    smoothWheel: true,
    wheelMultiplier: 1,
    duration: 1,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    smoothTouch: false, // Mobile
    touchMultiplier: 2, // sensibility on mobile
    infinite: false, // Infinite scrolling
    prevent: (node) => {
      // Excluir modal-box y sus descendientes
      if (node.classList.contains('modal-box') || node.closest('.modal-box')) {
        return true
      }
      // Excluir contenedores con scroll interno (.opciones y elementos con overflow-y-auto)
      if (node.classList.contains('lenis-box') || node.closest('.lenis-box')) {
        return true
      }
      return false
    }
  })

  // Store the lenis instance on the window object for use in other modules
  window.lenisInstance = lenis

  /**
   * Resuelve el destino de un enlace ancla de ESTA página.
   * `href="#id"` se trata siempre como la página actual: el `<base href>` apunta
   * a la home, y el URL resuelto (`link.href`) llevaría al inicio.
   * @param {HTMLAnchorElement} link
   * @returns {HTMLElement|null}
   */
  const anchorTarget = (link) => {
    const href = link.getAttribute('href')
    if (!href || !href.includes('#')) return null

    const hashOnly = href.startsWith('#')
    const url = hashOnly ? null : new URL(link.href, window.location.href)
    const hash = hashOnly ? href : url.hash
    if (hash.length < 2) return null
    if (!hashOnly && url.pathname !== window.location.pathname) return null

    return hash === '#top' ? document.body : document.getElementById(decodeURIComponent(hash.slice(1)))
  }

  // Header fijo (desktop): el destino no debe quedar tapado.
  const headerOffset = () => {
    const menu = document.querySelector('.header-menu-row')
    return menu && window.innerWidth >= 992 ? menu.offsetHeight : (document.querySelector('.header-brand-row')?.offsetHeight || 0)
  }

  const scrollToElement = (targetElement, immediate = false) => {
    const targetTop = targetElement === document.body
      ? 0
      : targetElement.getBoundingClientRect().top + window.scrollY - headerOffset()
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight
    const targetPosition = Math.max(0, Math.min(targetTop, Math.max(maxScroll, 0)))

    lenis.scrollTo(targetPosition, {
      immediate,
      duration: 2,
      easing: (t) => 1 - Math.pow(1 - t, 6)
    })
  }

  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href*="#"]')
    if (!link) return
    const targetElement = anchorTarget(link)
    if (!targetElement) return

    e.preventDefault()
    scrollToElement(targetElement)
    if (link.hash && link.hash !== '#top') history.replaceState(null, '', link.hash)
  })

  // Llegada con hash desde otra página (menú "Staff" → /#staff).
  if (window.location.hash.length > 1) {
    const initial = document.getElementById(decodeURIComponent(window.location.hash.slice(1)))
    if (initial) window.addEventListener('load', () => scrollToElement(initial, true), { once: true })
  }

  // Conecta el sync Lenis → ScrollTrigger solo si GSAP ya está cargado.
  // Si GSAP llega después (carga dinámica), gsap.js llamará a connectGSAP().
  connectGSAP(lenis)

  return lenis
}

/**
 * Conecta el sync Lenis → ScrollTrigger, pero SOLO si GSAP existe.
 * Idempotente: no vuelve a conectar si ya estaba conectado.
 * @param {import('lenis').default} [lenis] - instancia de Lenis
 * @returns {boolean} true si quedó conectado en esta llamada
 */
export function connectGSAP (lenis = window.lenisInstance) {
  if (!lenis || lenis.__stConnected) return false
  if (!window.gsap || !window.ScrollTrigger) return false
  lenis.on('scroll', window.ScrollTrigger.update)
  lenis.__stConnected = true
  return true
}

export default lenisScroll
